import request from '@/utils/request'

// 验证身份信息
export const verifyIdentity = (data) => {
  return request({
    url: '/php/api/v1/trade/pwd/verify-identity',
    method: 'post',
    data
  })
}

// 重置交易密码
export const resetTradePwd = (data) => {
  return request({
    url: '/php/api/v1/trade/pwd/reset',
    method: 'post',
    data
  })
} 